// extracted by mini-css-extract-plugin
export default {"marker":"DisclaimerMarker_marker__nE-0F","link":"DisclaimerMarker_link__8GOI6"};